var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconConvenio(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22.73 15.154"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".icon_convenio_svg__b{fill:#2196f3}.icon_convenio_svg__c{fill:#6f6f6f}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-92 -67.466)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(92 67.466)"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "#6f6f6f",
    fill: "none"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22.73,
    height: 15.154,
    rx: 2,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 21.73,
    height: 14.154,
    rx: 1.5
  })), /*#__PURE__*/React.createElement("rect", {
    className: "icon_convenio_svg__b",
    width: 5.051,
    height: 0.609,
    rx: 0.304,
    transform: "translate(3.031 9.196)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "icon_convenio_svg__b",
    width: 7.577,
    height: 0.609,
    rx: 0.304,
    transform: "translate(3.031 11.515)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "icon_convenio_svg__c",
    d: "M.609 4.262h21.919v2.435H.609z"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "icon_convenio_svg__c",
    width: 3.044,
    height: 3.044,
    rx: 1,
    transform: "translate(95.254 69.901)"
  }))));
}
export default __webpack_public_path__ + "static/media/icon_convenio.ee694b92.svg";
export { SvgIconConvenio as ReactComponent };